<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!--  -->
    <!-- 重要指标 -->
    <index-common
      v-if="page.isIndex"
      v-loading="loading.indexLoading"
      element-loading-background="#FFF"
      element-loading-spinner="el-icon-loading"
      element-loading-customClass="defineLoading"
      element-loading-text="拼命的加载中"
      class="block-preview noCompare_min"
      :options="summaryList"
    >
    </index-common>
    <!-- 趋势图 -->
    <chart-content :flod="flod" v-if="page.isChart">
      <!-- 指标选择框 -->
      <div class="flex-between gragh-index">
        <!-- 图的指标 -->
        <component
          :is="page.selectChart"
          :class-key="page.chartKey"
          :number="page.chartNum"
          :indicator="page.indicator"
          :address="page.chartAddress"
        >
        </component>
        <!-- 按日等标签 -->
        <div v-if="page.isTime">
          <el-radio-group v-model="tabPosition">
            <el-radio-button label="byDay" v-if="page.isDay"
              >按日</el-radio-button
            >
            <el-radio-button :disabled="disabled[0]" label="byWeek"
              >按周</el-radio-button
            >
            <el-radio-button :disabled="disabled[1]" label="byMonth"
              >按月</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>
      <!-- 2个图 -->
      <div v-if="page.isTwo" :class="bigClass">
        <component
          v-if="!queryCommon.compareType"
          :is="page.firstChart"
          id="chart"
          :style="firstClass"
          v-loading="loading.pieLoading1"
          element-loading-background="#FFF"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="defineLoading"
          element-loading-text="拼命的加载中"
          :options="option1"
        ></component>
        <component
          v-if="!queryCommon.compareType"
          :is="page.secondChart"
          id="chart2"
          :style="secondClass"
          v-loading="loading.chartLoading1"
          element-loading-background="#FFF"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="defineLoading"
          element-loading-text="拼命的加载中"
          :options="option2"
          tag="1"
          :show="loading.chartLoading1"
        ></component>
        <component
          v-if="queryCommon.compareType"
          :is="page.compareChart"
          id="chart3"
          style="flex: 1"
          v-loading="loading.pieLoading2"
          element-loading-background="#FFF"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="defineLoading"
          element-loading-text="拼命的加载中"
          :options="option3"
        ></component>
        <component
          v-if="queryCommon.compareType"
          :is="page.compareChart"
          style="flex: 1"
          id="chart4"
          v-loading="loading.pieLoading3"
          element-loading-background="#FFF"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="defineLoading"
          element-loading-text="拼命的加载中"
          :options="option4"
        ></component>
      </div>
      <!-- 1个图 -->
      <component
        v-if="!page.isTwo"
        :is="page.oneChart"
        id="chart5"
        v-loading="loading.chartLoading"
        element-loading-background="#FFF"
        element-loading-spinner="el-icon-loading"
        element-loading-customClass="defineLoading"
        element-loading-text="拼命的加载中"
        :options="option5"
        :show="loading.chartLoading"
      >
      </component>
    </chart-content>

    <!-- 自定义指标、表格 -->
    <div
      style="position: relative"
      :class="page.isChart ? 'width-full padding-bottom-md' : 'graph-table'"
      v-if="page.isTable"
    >
      <zoom @zoom="changeflod" v-if="page.chartZoom"></zoom>
      <!-- 表的指标 -->
      <component
        :is="page.selectTable"
        :class-key="page.tableKey"
        :number="page.tableNum"
        :address="page.tableAddress"
      >
      </component>
      <div
        class="table_min"
        v-if="page.isTableKey"
        v-loading="loading.tableLoading"
        element-loading-background="#FFF"
        element-loading-spinner="el-icon-loading"
        element-loading-customClass="defineLoading"
        element-loading-text="拼命的加载中"
      >
        <component
          v-if="!queryCommon.compareType"
          :title="page.tableTitle"
          :is="page.normalTable"
          :tableInfo="tableInfo"
          :devsort-style="tableInfo.devsort"
          :focus="page.focus"
          :queryKey="queryKey"
        >
        </component>
        <component
          v-if="queryCommon.compareType"
          :title="page.tableTitle"
          :is="page.compareTable"
          :tableInfo="tableInfo"
          :devsort-style="tableInfo.devsort"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import * as queryUtil from '../../../common/query'
import * as util from '../../../common/util'
import * as consts from '../../../common/const'
import * as classCharts from '../chart/style_charts'
import * as Func from '../../../common/commonFun'
import { content } from './component'
import { param } from 'jquery'
const log = console.log.bind(console)
export default {
  components: {
    ...content,
  },
  props: {
    page: [Object],
    headerVal: [Object],
    header: [Object],
    queryKey: [String],
    headerShow: [Array],
  },
  data() {
    return {
      loading: {
        indexLoading: false,
        pieLoading: false,
        pieLoading1: false,
        chartLoading: false,
        chartLoading1: false,
        tableLoading: false,
        pieLoading2: false,
        pieLoading3: false,
      },
      query: {},
      // 表格
      tableInfo: {},
      // 指标
      summaryList: [],
      // 按周
      tabPosition: '',
      disabled: [false, false],
      flod: false,
      option1: {},
      option2: {},
      option3: {},
      option4: {},
      option5: {},
      limitNum: '1',
      pageNum: 1,
      weekShow: true,
      secondClass: '',
      firstClass: '',
      pie1Data: [],
      twoPieName: [],
    }
  },
  created() {
    console.log(this.page, 'this.page')
    this.limitNum = this.page.chartNum
    if (this.headerVal !== undefined && Object.keys(this.headerVal).length) {
      this.changeHeader(this.headerVal.time)
    }
    // 项目分类，刚开始为一个饼图，点击下钻时为2个
    if (this.page.firstChart === this.page.secondChart) {
      this.secondClass = ''
      this.firstClass = 'flex:1'
      this.bigClass = 'flex-nowrap flex-center-center'
    } else {
      // 饼图+趋势
      this.firstClass = ''
      this.secondClass = 'width: 70%; position:relative'
      this.bigClass = 'flex-nowrap pie-spine flex-main-start'
    }
    if (this.page.isChart) {
      if (this.page.isTime) {
        // 没有日
        if (!this.page.isDay) {
          this.tabPosition = 'byWeek'
        } else {
          // 有日
          // 上周
          if (this.header.quckTime === 'TimeTab') {
            this.disabled = [true, true]
          } else if (this.header.quckTime === 'MonthTabTwo') {
            // 上月
            this.disabled = [false, true]
          }
          this.tabPosition = 'byDay'
        }
      } else {
        if (!this.page.isDay) {
        }
      }
    }
    // 特殊情况，理疗师详情页面的留存趋势，要按月显示
    if (
      this.page.xname === 'save' ||
      this.page.xname === 'cust_target_trend' ||
      this.page.xname === 'member_level_growth' ||
      this.page.xname === 'member_level_trend'
    ) {
      this.tabPosition = 'byMonth'
      queryUtil.setQueryTable({ byWhichWay: 'byMonth' })
    }
  },
  computed: {
    // 下钻饼图的pieIndex
    pieIndex() {
      return this.$store.state.pieIndex
    },
    // 公共数据
    queryCommon() {
      // 对比时只能选择一个
      if (this.$store.state.query_common.compareType) {
        this.page.chartNum = '1'
      } else {
        this.page.chartNum = this.limitNum
      }
      return this.$store.state.query_common
    },
    queryTable() {
      console.log(this.$store.state.query_data, 'this.$store.state.query_data')
      const log = console.log.bind(console)
      return Object.assign(
        {},
        this.$store.state.query_common,
        this.$store.state.query_table
      )
    },
    queryIndex() {
      return Object.assign(
        {},
        this.$store.state.query_common,
        this.$store.state.query_table
      )
    },
    queryPie() {
      return Object.assign(
        {},
        this.$store.state.query_data,
        this.$store.state.query_common
      )
    },
    // queryFunnel(v) {
    //     // 切换其他页面，pie的监听会出发，所以禁止调用pie接口
    //     return Object.assign(
    //         {},
    //         this.$store.state.query_data,
    //         this.$store.state.query_common
    //     )
    // },
    queryChart() {
      log('query_data on change, update query chart')

      // log(JSON.stringify(this.$store.state.query_data, null, 4) )
      // log(JSON.stringify(this.$store.state.query_common, null, 4) )
      Object.assign(
        {},
        this.$store.state.query_data,
        this.$store.state.query_common,
        {
          byWhichWay: this.tabPosition,
        }
      )

      return Object.assign(
        {},
        this.$store.state.query_data,
        this.$store.state.query_common,
        {
          byWhichWay: this.tabPosition,
        }
      )
    },
    queryPieData() {
      if (this.$store.state.pieIndex.index === '') {
        return ''
      } else {
        return this.pie1Data[this.$store.state.pieIndex.index]
      }
    },
  },
  watch: {
    queryTable: {
      handler: function (v, v1) {
        const log = console.log.bind(console)
        // log('content - query table v', v.identifyKey)
        this.getTable(v)
      },
      deep: true,
    },
    queryIndex(v) {
      this.getIndex(v)
    },
    queryPie(v) {
      // 切换其他页面，pie的监听会出发，所以禁止调用pie接口
      if (this.page.isTwo) {
        this.getChartPie(v)
      }
    },
    // queryFunnel(v) {
    //     // 切换其他页面，pie的监听会出发，所以禁止调用pie接口
    //     if (this.page.isTwo) {
    //         this.getChartFunnel(v)
    //     }
    // },
    queryChart(v) {
      this.getChart(v)
    },
    queryPieData(v) {
      this.getDeepPie(v)
    },
    'headerVal.time': {
      deep: true, // 深度监听设置为 true
      handler: function (newV) {
        this.changeHeader(newV)
      },
    },
    pieIndex(v) {
      if (v.index !== '') {
        this.secondClass = 'flex:1'
      }
    },
  },
  methods: {
    // 关键指标
    getIndex(params) {
      // 理疗师详情和增长页面，没有选中理疗师，则拦截请求
      if (
        this.$route.name === 'perform_analyze' ||
        this.$route.name === 'perform_target_trend'
      ) {
        if (params.empID === undefined) return
      }
      // 单店趋势页面， 如果没有选门店，则拦截请求
      if (this.$route.name === 'single_trend') {
        if (params.storeIDs === undefined) return
      }
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf('indicatorIDs') >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        )
        queryUtil.changeIndexParams(params)
        params.constantType = [17, 18, 19].includes(params.constantType)
          ? params.constantType
          : this.page.TableconstantType
        // 增长里面 关键指标为对比形式，所以选传IndexCompareType为1，单独请求
        if (this.page.isIndex && this.page.IndexCompareType !== undefined) {
          let a = params
          a.compareType = this.page.IndexCompareType
          Func.getIndex(this, a)
        } else if (
          this.page.xname === 'customerClass' ||
          this.page.xname === 'AfterPrice111'
        ) {
          // 理疗师详情的客户类型的关键指标和时间表的identifyKey不一样
          let a = { ...params }
          a.identifyKey = this.page.indicatorKey
          Func.getIndex(this, a)
        } else {
          // 正常情况
          Func.getIndex(this, params)
        }
      }
    },
    // 查询表格数据
    getTable(params) {
      const log = console.log.bind(console)
      // log('getTable Params', params.identifyKey)
      // log('get table params', params.sortIndex)
      //  console.log(params);
      //  console.log("this.$route.name=>",this.$route.name)
      //  console.log("this.page.name=>",this.page.name)
      // 理疗师详情和增长页面，没有选中理疗师，则拦截请求
      if (
        this.$route.name === 'perform_analyze' ||
        this.$route.name === 'perform_target_trend'
      ) {
        if (params.empID === undefined) return
      }
      if (this.$route.name === 'single_trend') {
        if (params.storeIDs === undefined) return
      }
      // 会员等级趋势
      if (this.$route.name === 'member_level_trend') {
        params.byWhichWay = 'byMonth'
      }
      if (this.$route.name === 'member_level_growth' && this.page.tableKey === 'member_level_ring_growth_table') {
        params.customerType = -1
      }
      // 正常的有关键指标，也有图表
      // log('-------- compare -------')
      // log(this.page)
      // log(Object.keys(params).indexOf('indicatorIDs') >= 0)
      // log(this.page.isTableKey)
      // log('-------- compare -------')
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf('indicatorIDs') >= 0 &&
        this.page.isTableKey
      ) {
        log('进入 if')
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        )
        params.constantType = [17, 18, 19].includes(params.constantType)
          ? params.constantType
          : this.page.TableconstantType
        log('-------this.page.normalTable', this.page.normalTable)
        if (this.page.normalTable === 'ColorTable') {
          Func.getColorTable(this, params)
        } else if (
          ['ColorTables', 'IndexTable'].includes(this.page.normalTable)
        ) {
          let title = this.page.tableTitle
          // log('title is', title)
          let list = ['理疗师', '前台']
          if (list.includes(title)) {
            params.sortIndex -= 1
            log(`title is (${title}), sorIndex = (${params.sortIndex})`)
          }

          if (title === '前台') {
            params.postType = 2
          }
          Func.getColorTables(this, params)
        } else if (
          this.page.normalTable === 'OneTable' &&
          !this.queryCommon.compareType
        ) {
          Func.getOneTable(this, params)
        } else if (
          this.page.normalTable === 'ContrantTable' ||
          (this.page.compareTable === 'ContrantTable' &&
            this.queryCommon.compareType)
        ) {
          Func.getContastTable(this, params)
        } else if (this.page.normalTable === 'DateTable') {
          log(params)
          Func.getDateTable(this, params)
        } else if (
          this.page.normalTable === 'OneLevel' ||
          (this.page.compareTable === 'OneLevel' &&
            this.queryCommon.compareType)
        ) {
          Func.getOneLevel(this, params)
        } else if (this.page.normalTable === 'TableCard') {
          // 针对 运营  --- 销售分析 --- 客单价--拓客分布tab
          if (this.page.xname === 'AfterPrice111') {
            params.identifyKey = this.page.indicatorKey
          }
          Func.getTableCard(this, params)
        } else if (this.page.normalTable === 'AreaTable') {
          Func.getAreaTable(this, params)
        } else if (this.page.normalTable === 'TableAnalysis') {
          Func.getAnalysisTable(this, params)
        }
      }
    },
    // 查询chart
    getChart(params) {
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf('indicatorIDs') >= 0
      ) {
        // 理疗师详情和增长页面，没有选中理疗师，则拦截请求
        if (
          params.empID === undefined &&
          this.$route.name === 'perform_analyze'
        )
          return
        if (
          params.empID === undefined &&
          this.$route.name === 'perform_target_trend'
        )
          return
        if (
          this.$route.name === 'single_trend' &&
          params.storeIDs === undefined
        )
          return
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        )
        queryUtil.changeTrendParams(params)
        params.constantType = this.page.ChartconstantType
        if (this.page.oneChart === 'VueHighchart') {
          // 单一的趋势图
          console.log('单一趋势图参数', params, this.$route.name)
          // 会员等级趋势，趋势图
          if (['member_level_trend', 'member_level_growth'].includes(this.$route.name)) {
            params.byWhichWay = 'byMonth'
          }
          Func.getTrend(this, params)
        } else if (
          this.page.secondChart === 'AsideTrend' &&
          this.page.oneChart === ''
        ) {
          console.log(1111)
          // 饼图+趋势图的趋势图
          Func.getTwoTrend(this, params)
        } else if (this.page.oneChart === 'VueColumn') {
          if (this.page.chartSort) {
            // 排序的柱状图
            Func.getSortCloumn(this, params)
          } else {
            // 不排序的柱状图
            Func.getCloumn(this, params)
          }
        } else if (this.page.oneChart === 'WordCloud') {
          //
          Func.getWordCloud(this, params)
        } else if (this.page.oneChart === 'ChartHeatmap') {
          // 热力图
          params.constantKeyAxis = this.page.constantKeyAxis
          Func.getHeatmap(this, params)
        } else if (this.page.oneChart === 'Sangkey') {
          // 桑基图
          Func.getSangkey(this, params)
        } else if (this.page.oneChart === 'Funnel') {
          // 桑基图
          Func.getFunnel(this, params)
        } else {
          console.error('this.page oneChart is ', this.page.oneChart)
        }
        return params
      } else if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf('indicatorID') >= 0
      ) {
        if (this.page.oneChart === 'WordCloud') {
          queryUtil.changeParams(
            this.headerShow,
            params,
            this.page.tableTitle,
            this.header.contrast
          )
          queryUtil.changeTrendParams(params)
          params.constantType = this.page.ChartconstantType
          //
          log('one chart')
          Func.getWordCloud(this, params)
        } else if (this.page.oneChart === 'treeChart') {
          queryUtil.changeParams(
            this.headerShow,
            params,
            this.page.tableTitle,
            this.header.contrast
          )
          queryUtil.changeTrendParams(params)
          params.constantType = this.page.ChartconstantType
          //
          Func.getTreeChart(this, params)
        }
      }
    },
    // getChartFunnel(params){
    //     console.log(params,'params' , this.page)
    //     if (this.page.firstChart === 'Funnel') {
    //             // console.log(params);
    //             Func.getFunnelTwoTrend(this, params)
    //             console.log(this.option1)
    //         }
    // },
    getChartPie(params) {
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf('indicatorIDs') >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        )
        queryUtil.changeTrendParams(params)
        params.constantType = this.page.PieconstantType
        // 饼图+趋势图的饼图
        if (
          this.page.firstChart === 'VuePie' &&
          this.page.secondChart !== 'VuePie'
        ) {
          // console.log(params);
          Func.getPie(this, params)
        } else if (
          this.page.firstChart === 'VuePie' &&
          this.page.secondChart === 'VuePie'
        ) {
          // 带下钻的饼图，不对比的饼图1和对比是的2个饼图1
          Func.getOnePie(this, params)
        }
      }
    },
    // 下钻的饼图2
    getDeepPie(params) {
      console.log(2)
      console.log(params)
      console.log(this)
      if (
        params !== undefined &&
        params !== '' &&
        !this.queryCommon.compareType
      ) {
        let a = {}
        if (this.queryKey === 'categoryID') {
          a = {
            categoryID: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3,
          }
        } else if (this.queryKey === 'cardType') {
          a = {
            cardType: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3,
          }
          console.log(a)
        } else if (this.queryKey === 'timeLength') {
          a = {
            timeLength: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3,
          }
        } else if (this.queryKey === 'price') {
          let miniPrice = 0
          let maxPrice = 0
          switch (params.name) {
            case '小于300元':
              miniPrice = 0
              maxPrice = 300
              break
            case '大于800':
              miniPrice = 800
              maxPrice = 0
              break
            default:
              let c = params.name.split('-')
              let d = c[1].split('元')
              miniPrice = parseInt(c[0])
              maxPrice = parseInt(d[0])
              break
          }
          a = {
            miniPrice: miniPrice,
            maxPrice: maxPrice,
            constantType: 8,
            type: 3,
          }
        } else {
          a = {
            parentID: params.valueOrID,
            constantType: this.page.PieconstantType,
            type: 3,
          }
        }
        // 不能直接改this.queryCommon，要不然第一个饼图会重新获取
        // this.queryCommon.categoryID=params.valueOrID
        // this.queryCommon.constantType=this.page.PieconstantType
        // queryUtil.changeParams(this.headerShow, this.queryCommon, this.page.tableTitle, this.header.contrast)
        queryUtil.changeParams(
          this.headerShow,
          this.queryCommon,
          this.page.tableTitle,
          this.header.contrast
        )
        queryUtil.changeTrendParams(this.queryCommon)
        let arg = Object.assign(
          {},
          this.queryCommon,
          this.$store.state.query_data,
          a
        )
        Func.getDeepPie(this, arg)
      }
    },
    change_header(val) {
      let tab = util.byWatch(val, this.tabPosition)
      tab.disabled.forEach((item, index) => {
        this.disabled.splice(index, 1, item)
      })
      this.tabPosition = tab.tabPosition
      this.disabled = [true, true]
    },
    changeflod(val) {
      this.flod = val
    },
    // 表头时间改变，改变按日，按周，按月的选择禁用
    changeHeader(val) {
      let time_block = util.report.timeinterval(val)
      this.disabled = [true, true]
      // 按周
      if (time_block >= 8 && time_block < 32) {
        this.disabled.splice(0, 1, false)
      } else if (time_block >= 32) {
        // 按月
        this.disabled.splice(0, 2, false)
      } else {
        // 按日
        if (this.page.isDay) {
          this.tabPosition = 'byDay'
        } else {
          this.disabled.splice(0, 1, false)
          this.tabPosition = 'byWeek'
        }
      }
    },
  },
}
</script>

<style lang="less"></style>
